import { render, staticRenderFns } from "./index.vue?vue&type=template&id=54652d81&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=54652d81&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=54652d81&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54652d81",
  null
  
)

export default component.exports